import {
    type BatchCreateDriveFolderHierarchyResponseType,
    type BatchCreateDriveFolderHierarchyRequestType
} from "./type";
import {
    request
} from "../request";

const BatchCreateDriveFolderHierarchy = async (
    params: BatchCreateDriveFolderHierarchyRequestType
): Promise<BatchCreateDriveFolderHierarchyResponseType> => {
    return await request<BatchCreateDriveFolderHierarchyResponseType>("/drive/batchCreateDriveFolderHierarchy", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default BatchCreateDriveFolderHierarchy;
